import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import quantaLogo from "../assets/quanta.png";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ fullName: "", email: "", password: "", confirmPassword: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (form.password !== form.confirmPassword) return setError("Password and confirm password must match");
    if (form.password.length < 8) return setError("Password must be at least 8 characters");
    setLoading(true);
    try {
      await register({ fullName: form.fullName, email: form.email, password: form.password, roleId: 0, companyId: null, isActive: true });
      setMessage("Admin account created successfully. Please login and setup company details.");
      setTimeout(() => navigate("/login"), 900);
    } catch (err) {
      setError(err.userMessage || err.response?.data || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center p-3" style={{ background: "linear-gradient(135deg, #07111f 0%, #14b8a6 100%)" }}>
      <div className="row g-0 shadow-lg overflow-hidden" style={{ width: "min(980px, 100%)", borderRadius: 24, background: "rgba(255,255,255,.96)" }}>
        <div className="col-lg-6 d-none d-lg-flex flex-column justify-content-between p-4 text-white" style={{ background: "linear-gradient(160deg, #07111f, #5f2a6d)" }}>
          <div>
            <img src={quantaLogo} alt="Quanta ERP" style={{ width: "78%", maxWidth: 300, height: "auto", marginLeft: -12 }} />
            <h3 className="fw-bold mt-3">Create Quanta ERP Admin</h3>
            <p className="small mb-0" style={{ opacity: .85 }}>Create the first administrator, then continue with company setup and secure role-based access.</p>
          </div>
          <div className="row g-2 small">
            {["First Admin", "Password Hash", "Role Ready", "Company Setup"].map((x) => (
              <div className="col-6" key={x}>
                <div className="rounded-4 p-2" style={{ background: "rgba(255,255,255,.12)" }}><i className="bi bi-check2-circle me-1"></i>{x}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-lg-6 p-4 p-md-5">
          <div className="mb-4">
            <div className="badge rounded-pill mb-2" style={{ background: "#07111f" }}>Secure Admin Registration</div>
            <h4 className="fw-bold mb-1">Create admin account</h4>
            <p className="text-muted small mb-0">This account will be used to login, setup company details and configure users.</p>
          </div>

          {error && <div className="alert alert-danger py-2 small">{String(error)}</div>}
          {message && <div className="alert alert-success py-2 small">{message}</div>}

          <form onSubmit={submit} className="d-grid gap-3">
            <div>
              <label className="form-label small fw-semibold">Full Name</label>
              <div className="input-group input-group-sm">
                <span className="input-group-text"><i className="bi bi-person"></i></span>
                <input className="form-control" value={form.fullName} onChange={(e) => setForm({ ...form, fullName: e.target.value })} placeholder="Enter admin full name" required />
              </div>
            </div>

            <div>
              <label className="form-label small fw-semibold">Email</label>
              <div className="input-group input-group-sm">
                <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                <input type="email" className="form-control" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="admin@company.com" required />
              </div>
            </div>

            <div className="row g-2">
              <div className="col-md-6">
                <label className="form-label small fw-semibold">Password</label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text"><i className="bi bi-shield-lock"></i></span>
                  <input type="password" className="form-control" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Minimum 8 characters" required />
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-semibold">Confirm Password</label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text"><i className="bi bi-lock-fill"></i></span>
                  <input type="password" className="form-control" value={form.confirmPassword} onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })} placeholder="Re-enter password" required />
                </div>
              </div>
            </div>

            <button className="btn btn-sm text-white py-2" style={{ background: "linear-gradient(90deg,#0b4f4a,#0f766e)", border: 0, borderRadius: 10 }} disabled={loading}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2" />Creating admin...</> : <><i className="bi bi-person-plus me-2"></i>Create Admin</>}
            </button>
          </form>

          <div className="small text-center mt-4">Already registered? <Link to="/login" className="fw-semibold">Login</Link></div>
        </div>
      </div>
    </div>
  );
}
